import * as Types from '@/types';

import * as Apollo from '@apollo/client';
import { gql } from '@apollo/client';
import { useLazyQuery } from '@/hooks/use-lazy-query';
import { useWrappedQuery } from '@/hooks/use-wrapped-query';
const defaultOptions = {} as const;

export const SalesPortalProspectFinderNearbyBusinessesDocument = gql`
  query SalesPortalProspectFinderNearbyBusinesses(
    $categories: String
    $isCurrentRestaurant: Boolean
    $keyword: String
    $latitude: Float
    $location: String
    $longitude: Float
    $offset: Int
    $price: String
    $radius: String
    $limit: Int
    $sortBy: String
    $supplierUUID: uuid!
  ) {
    getNearbyBusinessesV2(
      categories: $categories
      is_current_restaurant: $isCurrentRestaurant
      keyword: $keyword
      latitude: $latitude
      location: $location
      longitude: $longitude
      offset: $offset
      price: $price
      radius: $radius
      limit: $limit
      sort_by: $sortBy
    ) {
      business_display_address
      business_name
      categories
      distance
      image_url
      latitude
      longitude
      phone_number
      restaurant_uuid
      status
      supplier_uuid
      yelp_business_id
    }
    businesses_by_pk(uuid: $supplierUUID) {
      uuid
      address {
        country_code
        uuid
      }
    }
  }
`;
export function useSalesPortalProspectFinderNearbyBusinessesQuery(
  baseOptions: Apollo.QueryHookOptions<
    Types.SalesPortalProspectFinderNearbyBusinessesQuery,
    Types.SalesPortalProspectFinderNearbyBusinessesQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    Types.SalesPortalProspectFinderNearbyBusinessesQuery,
    Types.SalesPortalProspectFinderNearbyBusinessesQueryVariables
  >(SalesPortalProspectFinderNearbyBusinessesDocument, options);
}
export function useSalesPortalProspectFinderNearbyBusinessesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    Types.SalesPortalProspectFinderNearbyBusinessesQuery,
    Types.SalesPortalProspectFinderNearbyBusinessesQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    Types.SalesPortalProspectFinderNearbyBusinessesQuery,
    Types.SalesPortalProspectFinderNearbyBusinessesQueryVariables
  >(SalesPortalProspectFinderNearbyBusinessesDocument, options);
}
export type SalesPortalProspectFinderNearbyBusinessesQueryHookResult =
  ReturnType<typeof useSalesPortalProspectFinderNearbyBusinessesQuery>;
export type SalesPortalProspectFinderNearbyBusinessesLazyQueryHookResult =
  ReturnType<typeof useSalesPortalProspectFinderNearbyBusinessesLazyQuery>;
export type SalesPortalProspectFinderNearbyBusinessesQueryResult =
  Apollo.QueryResult<
    Types.SalesPortalProspectFinderNearbyBusinessesQuery,
    Types.SalesPortalProspectFinderNearbyBusinessesQueryVariables
  >;

/**
 * Wrapped version of useGeneratedSalesPortalProspectFinderNearbyBusinessesQuery using Pepper's useWrappedQuery
 */
export function useGeneratedSalesPortalProspectFinderNearbyBusinessesQuery(
  options?: Apollo.QueryHookOptions<
    Types.SalesPortalProspectFinderNearbyBusinessesQuery,
    Types.SalesPortalProspectFinderNearbyBusinessesQueryVariables
  >,
) {
  return useWrappedQuery<
    Types.SalesPortalProspectFinderNearbyBusinessesQuery,
    Types.SalesPortalProspectFinderNearbyBusinessesQueryVariables
  >(SalesPortalProspectFinderNearbyBusinessesDocument, options);
}

/**
 * Wrapped version of useGeneratedSalesPortalProspectFinderNearbyBusinessesLazyQuery using Pepper's useLazyQuery
 */
export function useGeneratedSalesPortalProspectFinderNearbyBusinessesLazyQuery(
  lazyOptions?: Omit<
    Apollo.QueryOptions<Types.SalesPortalProspectFinderNearbyBusinessesQueryVariables>,
    'query'
  >,
) {
  return useLazyQuery<
    Types.SalesPortalProspectFinderNearbyBusinessesQuery,
    Types.SalesPortalProspectFinderNearbyBusinessesQueryVariables
  >(SalesPortalProspectFinderNearbyBusinessesDocument, lazyOptions);
}
